// extracted by mini-css-extract-plugin
export default {"app":"DxWp","rect":"KJFi","drop":"gbTS","screen":"QLwF","panel":"gFzU","state":"N6lL","bottom":"OIin"};